import { Grid } from "@mui/material";
import {
  SelectInput,
  AutocompleteInput,
  ReferenceInput,
  required,
  FormDataConsumer,
  FileInput,
  SaveButton,
  FileField,
} from "react-admin";
import { Box, Typography } from "@mui/material";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import SendIcon from "@mui/icons-material/Send";
import ResetButton from "../Requests/components/ResetButton";
import { validateEnd, validateStart } from "components/Leaves/Requests/utils/validations";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { employeeRequests } from "api/employeeApi";
import { DocumentEditRow } from "components/Leaves/components/DocumentEditRow";
import { useNavigate } from "react-router-dom";

const SaveForm = ({ isCreate, onDocumentDelete, setLeaveId }) => {
  const navigate = useNavigate();

  return (
    <Grid
      container
      spacing={0}
      sx={{ width: "fit-content" }}
    >
      <Grid
        item
        xs={12}
        p={0.5}
      >
        <SecuredComponent permission={permissions.canRequestLeavesForAllEmployees}>
          <ReferenceInput
            source="employeeId"
            reference={employeeRequests.getEmployeesSelect()}
          >
            <AutocompleteInput
              label="Служител"
              optionText={record => `${record.firstName} ${record.lastName}`}
              readOnly={!isCreate}
              filterToQuery={() => ({})}
              matchSuggestion={(filter, choice) =>
                `${choice.firstName} ${choice.lastName}`.toLowerCase().includes(filter?.toLowerCase() || "")
              }
            />
          </ReferenceInput>
        </SecuredComponent>
        <ReferenceInput
          source="sickLeaveType"
          reference={employeeRequests.getSickLeaveTypesSelect()}
        >
          <SelectInput
            label="Тип болничен"
            optionText="nameBg"
            validate={required()}
          />
        </ReferenceInput>
        <FormDataConsumer>
          {({ formData }) => {
            return (
              <>
                <Grid
                  container
                  spacing={2}
                >
                  <Grid
                    item
                    xs={6}
                  >
                    <CustomDateInput
                      label="От дата"
                      source="dateFrom"
                      noTime
                      required={true}
                      validate={() =>
                        validateStart(
                          formData.dateFrom,
                          formData.dateTo,
                          required,
                          "Крайният ден не може да бъде по-малък от началният",
                        )
                      }
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                  >
                    <CustomDateInput
                      label="До дата"
                      source="dateTo"
                      noTime
                      required={true}
                      validate={() =>
                        validateEnd(
                          formData.dateTo,
                          formData.dateFrom,
                          required,
                          "Крайният ден не може да бъде по-малък от началният",
                        )
                      }
                    />
                  </Grid>
                </Grid>
              </>
            );
          }}
        </FormDataConsumer>

        {isCreate && (
          <>
            <FileInput
              accept={{ "image/*": [".jpg", ".jpeg", ".png"] }}
              placeholder={
                <Box sx={{ display: "flex", justifyContent: "center", gap: 2, py: 0.5 }}>
                  <UploadFileIcon color="primary" />
                  <Typography>Прикачи снимка на болничен лист</Typography>
                </Box>
              }
              label="Документ"
              source="document"
              validate={required("Моля прикачете снимка на болничен лист !")}
            >
              <FileField
                source="src"
                title="title"
              />
            </FileInput>
          </>
        )}
        {!isCreate && (
          <DocumentEditRow numberSource="documentNumber" onDocumentDelete={onDocumentDelete} />
        )}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <ResetButton
           onReset={() => (isCreate ? setLeaveId?.("") : navigate(-1))}
          />
          <SaveButton
            label="Запази"
            variant="contained"
            color="success"
            sx={{ padding: "0.5rem" }}
            icon={<SendIcon />}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default SaveForm;
